// extracted by mini-css-extract-plugin
export default {"container":"styles_container__jr282","form":"styles_form__mS5t3","btnWrapper":"styles_btnWrapper__MK46J","skipButton":"styles_skipButton__4EUNW"};